import DocxIcon from '~assets/images/docx.svg?react';
import PdfIcon from '~assets/images/pdf.svg?react';
import XlsxIcon from '~assets/images/xlsx.svg?react';
import ZipIcon from '~assets/images/zip.svg?react';

import { FileExtTypeEnum } from '../types/FileExtTypeEnum';

export class FileIconHelper {
  /**
   * Создаёт маппинг расширений файлов к их SVG-иконкам
   * @returns Объект с иконками, где ключ - тип расширения файла
   */
  static getFileIconsMap(): Record<FileExtTypeEnum | string, React.FC<React.SVGProps<SVGSVGElement>>> {
    return {
      [FileExtTypeEnum.PDF]: PdfIcon,
      [FileExtTypeEnum.XLSX]: XlsxIcon,
      [FileExtTypeEnum.XLS]: XlsxIcon,
      [FileExtTypeEnum.DOCX]: DocxIcon,
      [FileExtTypeEnum.DOC]: DocxIcon,
      [FileExtTypeEnum.ZIP]: ZipIcon,
    };
  }

  /**
   * Получает иконку для указанного расширения файла
   * @param fileExt - расширение файла (например, 'pdf', 'xlsx', 'docx')
   * @returns Компонент иконки
   */
  static getFileIcon(
    fileExt: FileExtTypeEnum | string | null | undefined,
  ): React.FC<React.SVGProps<SVGSVGElement>> | null {
    if (!fileExt) {
      return null;
    }

    const iconsMap = this.getFileIconsMap();

    return iconsMap[fileExt] || null;
  }
}
